import React from 'react';
import ReactSignatureCanvas from 'react-signature-canvas';
import { v4 as uuid } from 'uuid';

import classes from './SignPad.module.scss';

export const convertToFile = async (url: string, fileName: string): Promise<File> => {
    return fetch(url)
        .then(res => res.blob())
        .then(blob => {
            return new File([blob], fileName, { type: 'image/png' });
        });
};

interface SignPadProps {
    height?: number;
    onChange?: (file: File | null) => void;
}

export type SignPadRef = ReactSignatureCanvas;

export const SignPad = React.forwardRef<SignPadRef, SignPadProps>((props: SignPadProps, ref) => {
    const endSignHandler = async () => {
        if (!ref || typeof ref === 'function') return;
        const isEmpty = ref.current?.isEmpty();

        if (isEmpty) {
            return props.onChange?.(null);
        }

        const file = await convertToFile(
            ref.current?.getTrimmedCanvas().toDataURL('image/png') as string,
            `${uuid()}.png`
        );

        props.onChange?.(file);
    };

    return (
        <div
            className={classes.root}
            style={
                {
                    '--sign-pad-height': `${props.height}px`
                } as React.CSSProperties
            }
        >
            <ReactSignatureCanvas
                ref={ref}
                penColor="black"
                canvasProps={{ height: props.height }}
                onEnd={endSignHandler}
            />
        </div>
    );
});

SignPad.displayName = 'SignPad';
